export default "__VITE_ASSET__xnjmcN2m__"